import { NotificationList } from '@common/components/utility';
import { HospitalMainNavBar } from '@hospital/components/layout/nav/HospitalMainNavBar';
import { componentUtility } from '@hospital/utils';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
export interface IHospitalPageProps {
    hideBreadcrumbs?: boolean;
    pageContentClass?: string;
    navBarMinWidth?: string;
}

interface IPageNavProps {

}

const PageNav = (props: React.PropsWithChildren<IPageNavProps>) => {
    return (
        <>
            {props.children}
        </>
    );
}

export interface HospitalPageTitleProps {
    text?: string;
}

const PageTitle = (props: React.PropsWithChildren<HospitalPageTitleProps>) => {
    if (props.text) {
        return (
            <h1 className="page-header">{props.text}</h1>
        )
    }
    return (
        <>
            {props.children ? props.children : <></>}
        </>
    )
}

export interface HospitalContentProps {
}

const Content = (props: React.PropsWithChildren<HospitalContentProps>) => {
    return (
        <>
            {props.children}
        </>
    );
}

export interface HospitalSideBarProps {
    title?: string;
    className?: string;
}

const SideBar = (props: React.PropsWithChildren<HospitalSideBarProps>) => {
    return (
        <>
            <div className={classNames("page-sideBar page-sideBar__right", props.className)}>
                {props.title &&
                    <h3 className="title">{props.title}</h3>
                }
                {props.children}
            </div>
        </>
    )
}

const HospitalPage = observer((props: React.PropsWithChildren<IHospitalPageProps>) => {
    const { children } = props;
    const pageNav = componentUtility.findByType(children, PageNav);
    const pageTitleComponent = componentUtility.findByType(children, PageTitle);
    const contentComponent = componentUtility.findByType(children, Content);
    const sideBarComponent = componentUtility.findByType(children, SideBar);

    if (!contentComponent) {
        throw new Error('Expected Page.Content child on Page component, not supplied');
    }

    return (
        <>

            <div className="sticky-top d-flex flex-row" style={{ minWidth: props.navBarMinWidth }}>
                {
                    pageNav && pageNav
                }
                {
                    !pageNav &&
                    <HospitalMainNavBar />
                }
                <NotificationList />
            </div>
            <div className="d-flex justify-content-between flex-fill">
                <div className="d-flex flex-fill flex-column">
                    <div className={classNames("flex-fill align-items-left page-content", props.pageContentClass ? props.pageContentClass : "m-3")} >
                        {
                            pageTitleComponent ? pageTitleComponent : null
                        }
                        {contentComponent}
                    </div>
                </div>
                {
                    sideBarComponent && sideBarComponent
                }
            </div>
        </>

    )
});

const HospitalPageComponent = Object.assign(HospitalPage, {
    SideBar,
    Content,
    PageTitle,
    PageNav
});

export {
    HospitalPageComponent as HospitalPage
};
